import useUserStore from "../../utils/storeApp";
import useGcpUnavailableRedirect from "../../hooks/useGcpUnavailableRedirect";
import Users from "./users";
import GcpUsers from "./GcpUsers";

const UsersRouter = () => {
  const { userSession, backendTarget, userRole } = useUserStore((state) => ({
    userSession: state.userSession,
    backendTarget: state.backendTarget,
    userRole: state.userRole,
  }));
  const isGcpUser = !!userSession?.is_gcp_user || backendTarget === "gcp";
  const isRestrictedGcpUser =
    isGcpUser &&
    userRole !== "SES ADMINISTRATOR" &&
    userRole !== "SYSTEMADMINISTRATOR";

  useGcpUnavailableRedirect(isRestrictedGcpUser);

  if (isRestrictedGcpUser) {
    return null;
  }

  return isGcpUser ? <GcpUsers /> : <Users />;
};

export default UsersRouter;
